// Generated by Claude Code
import type { AnyRouter } from '@tanstack/react-router'

/** A company page given without its company: a path inside the company and the search to open it with. */
export interface CompanyLessAddress {
  pathname: string
  search?: Record<string, string>
}

/** Company-less addresses the backend sends out (e.g. in emails) that name a company page by another path. */
const ALIASES: Record<string, CompanyLessAddress> = {
  '/settings/users': { pathname: '/settings/users-teams', search: { tab: 'accessRequests' } },
}

/** The company page `pathname` stands for: an alias's page and search, else `pathname` itself. */
export function resolveCompanyLessAddress(pathname: string): CompanyLessAddress {
  return ALIASES[pathname.replace(/\/+$/, '')] ?? { pathname }
}

/**
 * `pathname` placed inside the company `segment` (`/analytics/work-orders` → `/acme/analytics/work-orders`),
 * or `null` when that does not land on a company page. Completes a shared link that leaves the company out.
 */
export function companyScopedPath(router: Pick<AnyRouter, 'getMatchedRoutes'>, segment: string, pathname: string): string | null {
  const candidate = '/' + segment + '/' + pathname.replace(/^\/+/, '')
  // A fuzzy (partial) match carries the unmatched remainder in `**`.
  const [, params, found] = router.getMatchedRoutes(candidate)
  return found && !params['**'] && params.companyId === segment ? candidate : null
}
